import { render, staticRenderFns } from "./c_ExpertTeam.vue?vue&type=template&id=b47b445e&scoped=true&"
import script from "./c_ExpertTeam.vue?vue&type=script&lang=js&"
export * from "./c_ExpertTeam.vue?vue&type=script&lang=js&"
import style0 from "./c_ExpertTeam.vue?vue&type=style&index=0&id=b47b445e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47b445e",
  null
  
)

export default component.exports